import React from 'react';
import PropTypes from 'prop-types';
import { RowData } from './RowData/RowData';

export const Body = ({ customTableSetup, datasource, headers }) => {
  const rowProps = customTableSetup?.body?.tr || {};

  const ActionCol = (props) => {
    const { id, attributes } = props;
    const actions = customTableSetup?.body?.actionCol?.actions || [];
    if(actions.length > 0) {
      const actionCol = customTableSetup?.body.actionCol;
      const classes = actions.length === 1 ? 'sm-action-data' : (actionCol.classes || 'action-data');

      return(
        <td className={`${classes}`}>
          {
            actions.map((action, index) => {
              if (action.conditionColumn) {
                const condition = attributes[action.conditionColumn.name];

                if(condition !== action.conditionColumn.value) return;
              }
              
              const Icon = action.icon;
              const customAttr = action.customAttr;
              const dataProps = customAttr ? { 'data-custom-column': attributes[customAttr]  } : {};

              return(
                <Icon key={`DataTable_Action_Col_${index}`} id={id} {...action.props} {...dataProps} />
              );
            })
          }
        </td>
      );
    }

    return null;
  };

  return (
    <tbody>
      {
        datasource.map((attributes, index) => {
          const customClassCondition = rowProps.customClassCondition ? rowProps.customClassCondition(attributes) : true;
          const customClass = rowProps.customClass ? rowProps.customClass : '';

          return (
            <tr key={`TR_${index}`} className={ customClassCondition ? customClass : '' }>
              <RowData data={attributes} headers={headers} />
              <ActionCol id={attributes.id} attributes={attributes} />
            </tr>
          );
        })
      }
      { 
        (!datasource || datasource?.length === 0) && 
        <tr>
          <td colSpan={ActionCol ? headers.length + 1 : headers.length}>Nenhum registro encontrado!</td>
        </tr> 
      }
    </tbody>
  );
};

Body.propTypes = {
  datasource: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  customTableSetup: PropTypes.object.isRequired
};
